import axiosService from '@/api/common/axios'

const api = {
  searchMenu: function () {
    return axiosService.get('/portal/menus')
  },

  searchMenuByMapSysNo: function (mapSysNo) {
    return axiosService.get('/portal/menus/' + mapSysNo)
  },

  searchStatItemList: function (mapSysNo) {
    return axiosService.get('/portal/menus/items/' + mapSysNo)
  },

  searchStatItem: function (mapItmNo) {
    return axiosService.get('/portal/menus/item/' + mapItmNo)
  },

  searchStatItemYear: function (mapSysNo) {
    return axiosService.get('/portal/menus/items/years/' + mapSysNo)
  }
}

export default api
